import { render } from "./SendInvoiceReceiverRows.vue?vue&type=template&id=1bfdb2e3&scoped=true&ts=true"
import script from "./SendInvoiceReceiverRows.vue?vue&type=script&lang=ts"
export * from "./SendInvoiceReceiverRows.vue?vue&type=script&lang=ts"

import "./SendInvoiceReceiverRows.vue?vue&type=style&index=0&id=1bfdb2e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfdb2e3"]])

export default __exports__